






























import { Component, Mixins } from 'vue-property-decorator'

import DefaultValueWrapper from '../../../DefaultValueWrapper.vue'
import MessageEditorWithMedia from '../../../MessageEditorWithMedia/MessageEditorWithMedia.vue'
import { MultiMessageEditorWithMediaData } from '../../../MultiMessageEditorWithMedia/types'
import { MediaEditorMode } from '../../../NewMessageEditors/types'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput, DefaultValueResetMixin } from '../../mixins'

@Component({
  components: {
    DefaultValueWrapper,
    MessageEditorWithMedia,
    FieldWrapper,
  },
})
export default class MessageEditorWithMediaInput extends Mixins(BaseInput, DefaultValueResetMixin) {
  editorMessageLimit = 4096

  filesToUploadLimit = 10

  downgradeCounterMax():void {
    this.editorMessageLimit = 1024
  }

  resetCounterMax():void {
    this.editorMessageLimit = 4096
  }

  mounted():void {
    if (this.settings.editorMode === MediaEditorMode.TelegramShort) {
      this.filesToUploadLimit = 1
    }
  }
}
